var ESortOptions = /* @__PURE__ */ ((ESortOptions2) => {
  ESortOptions2["noOrder"] = "noOrder";
  ESortOptions2["ascending"] = "ascending";
  ESortOptions2["descending"] = "descending";
  return ESortOptions2;
})(ESortOptions || {});
export {
  ESortOptions
};
